import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '../../lib/utils';

const Card = ({ children, className, animate = true }) => {
  const content = (
    <div className={cn(
      "bg-white p-3 md:p-4 lg:p-5 rounded-xl border border-gray-100 shadow-xl shadow-gray-200/20",
      className
    )}>
      {children}
    </div>
  );

  if (!animate) return content;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
    >
      {content}
    </motion.div>
  );
};

export default Card;